// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"927":"0e7e4ef7","983":"5b73a46d"}[chunkId] + ".css";
};